import AppBtn, {
  AppBtnColor,
  AppBtnRadius,
  AppBtnSize,
} from 'components/btn/AppBtn'
import Popup, { PopupSize } from 'components/popup/Popup'
import { AppScrollWrapperNew } from 'widgets/AppScrollWrapper/AppScrollWrapper'
import { AppInput } from 'components/AppInput/AppInput'
import { useTranslation } from 'react-i18next'
import { useEffect, useRef, useState } from 'react'

export type SelectPopupMode = 'millet' | 'dish' // можно расширять

interface ISelectPopupProps<T> {
  title?: string
  items: T[]
  selectedId?: number | string | null
  renderItem: (
    item: T,
    isSelected: boolean,
    onSelect: () => void,
  ) => React.ReactNode
  onSave: (selectedItem: T) => void
  onClose: () => void
  hasMore?: boolean
  onLoadMore?: () => void
  searchable?: boolean
  inputValue?: string
  onInputChange?: (val: string) => void
}

export function SelectPopup<T>({
  title,
  items,
  selectedId,
  renderItem,
  onSave,
  onClose,
  hasMore,
  onLoadMore,
  searchable = true,
  inputValue,
  onInputChange,
}: ISelectPopupProps<T>) {
  const { t } = useTranslation()
  // const [inputValue, setInputValue] = useState('')
  const [currentItem, setCurrentItem] = useState<T | null>(null)
  const refInput = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (!inputValue) return
    const timeout = setTimeout(() => {
      // пропусти вверх или локально отфильтруй, если нужно
    }, 500)
    return () => clearTimeout(timeout)
  }, [inputValue])

  return (
    <Popup size={PopupSize.md} borderRadiusMin closePopup={onClose}>
      <div className="popup-content-millet">
        <div className="header-popup">
          <h3>{title || t('Выбор')}</h3>
          <div className="popup-icon-close" onClick={onClose}>
            <i className="an-ico an-ico-close" />
          </div>
        </div>

        {searchable && onInputChange && (
          <AppInput
            ref={refInput}
            value={inputValue}
            onChange={onInputChange}
            placeholder={t('Поиск...')}
            fullWidth
            clear
          />
        )}

        <div className="wrap-millet">
          <AppScrollWrapperNew theme="dropdown">
            {items.map((item, index) => {
              const id = (item as any).id // привязка к id (можно вынести в пропс getId)
              const isSelected = id === (selectedId || (currentItem as any)?.id)
              return (
                <div key={index}>
                  {renderItem(item, isSelected, () => setCurrentItem(item))}
                </div>
              )
            })}
            {hasMore && onLoadMore && (
              <div onClick={(e) => e.stopPropagation()} className="mt-10">
                <AppBtn
                  title={t('Показать ещё')}
                  sized={AppBtnSize.fullWidth}
                  color={AppBtnColor.lightViolet}
                  radius={AppBtnRadius.base}
                  onClick={onLoadMore}
                />
              </div>
            )}
          </AppScrollWrapperNew>
        </div>

        <div className="buttons-block">
          <AppBtn
            title={t('Отменить')}
            color={AppBtnColor.outlineViolet}
            iconClassName="close"
            sized={AppBtnSize.md}
            onClick={onClose}
          />
          <AppBtn
            title={t('Сохранить')}
            color={AppBtnColor.violetWhite}
            iconClassName="save"
            sized={AppBtnSize.md}
            onClick={() => {
              if (currentItem) {
                onSave(currentItem)
              }
            }}
            disabled={!currentItem}
          />
        </div>
      </div>
    </Popup>
  )
}
